import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { ErrorModels } from 'models/error.model';
import { AsyncContentErrorDirective } from '../../directives';

@Component({
  selector: 'wz-async-content',
  templateUrl: './async-content.component.html',
  styleUrls: ['./async-content.component.scss'],
  standalone: false,
})
export class AsyncContentComponent implements OnInit {
  @ContentChild(AsyncContentErrorDirective, { static: true })
  errorTemplate: any;
  @Input()
  isLoading!: boolean;
  @Input()
  loadingText!: string;

  @Input()
  error!: string | ErrorModels.TunnelSanteError;

  constructor() {}

  ngOnInit() {}
}
